(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.LarrysaPlannerV1 = api;
  if (root && root.document) api.mount(root.document.getElementById('planner'));
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var FINAL_NOTICE = 'Valor final sujeito a confirmação de disponibilidade, personalização, data, hora e logística.';
  var WA_NUMBER = (typeof window !== 'undefined' && window.LARRYSA_WA) || '';

  var EVENTS = [
    ['crianca', 'Aniversário de criança'],
    ['infantil', 'Festa infantil'],
    ['adulto', 'Aniversário de adulto'],
    ['familiar', 'Festa familiar'],
    ['baby-shower', 'Baby shower'],
    ['empresa', 'Evento de empresa'],
    ['brunch', 'Lanche / brunch'],
    ['mesa-doce', 'Mesa doce'],
    ['decidir', 'Ainda estamos a decidir'],
  ];

  var COMPONENT_DEFINITIONS = [
    ['bolo', 'Bolo', 'Escolha os detalhes mais abaixo, se já tiver uma ideia.', 'bolos'],
    ['doces', 'Doces e sobremesas', 'Complementos doces escolhidos depois consigo.', 'sobremesas'],
    ['salgados', 'Salgados', 'Opções salgadas para compor a mesa.', 'salgados'],
    ['sugestao', 'Preciso de ajuda a escolher', 'Propomos uma combinação para a sua festa.', null],
  ];

  var CAKE_STYLES = [
    ['simples', 'Simples'],
    ['decorado', 'Decorado'],
    ['personalizado', 'Personalizado'],
    ['infantil', 'Infantil'],
    ['elegante', 'Elegante'],
    ['tema', 'Tema específico'],
  ];

  var LEVELS = [
    ['essencial', 'Essencial', 'Bonito, simples e bem composto.'],
    ['equilibrado', 'Equilibrado', 'A opção recomendada para impacto sem exagero.'],
    ['impacto', 'Impacto', 'Para uma festa com mais presença.'],
  ];

  var CAKE_CHOICES = [['include', 'Queremos incluir bolo'], ['have', 'Já temos bolo'], ['none', 'Não incluir bolo'], ['undecided', 'Ainda por decidir']];
  var FOOD_ROLES = [['meal', 'Lanche ou refeição principal'], ['complement', 'Complemento de outra mesa']];

  var RECEPTION = [
    ['levantamento', 'Recolha na Pontinha'],
  ];

  function initialState() {
    return {
      step: 1,
      flowVersion: 2,
      event: '',
      people: '',
      components: [],
      items: [],
      menuCategory: 'salgados',
      menuVariants: {},
      selectedCake: '',
      cakeChoice: '',
      foodRole: '',
      cakeStyle: '',
      colors: '',
      flavor: '',
      cakeMessage: '',
      inspiration: '',
      level: '',
      date: '',
      time: '',
      reception: 'levantamento',
      allergies: '',
      notes: '',
      area: '',
      budget: '',
      cakeDetailsOpen: false,
      extraDetailsOpen: false,
    };
  }

  // Only structured choices survive navigation. Personal notes remain in memory.
  function persistablePlan(value, catalog) {
    var source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    var clean = { step: source.flowVersion === 2 && [1, 2, 3, 4].includes(source.step) ? source.step : source.step === 3 ? 4 : [1, 2].includes(source.step) ? source.step : 1, people: '', components: [], date: '', time: '', selectedCake: '' };
    if (['string', 'number'].includes(typeof source.people) && /^\d+$/.test(String(source.people)) && Number(source.people) >= 1 && Number(source.people) <= 500) clean.people = String(source.people);
    [['event', EVENTS], ['cakeChoice', CAKE_CHOICES], ['foodRole', FOOD_ROLES], ['cakeStyle', CAKE_STYLES], ['level', LEVELS], ['reception', RECEPTION]].forEach(function (entry) {
      clean[entry[0]] = labelFor(entry[1], source[entry[0]]) ? source[entry[0]] : '';
    });
    if (Array.isArray(source.components)) clean.components = Array.from(new Set(source.components.filter(function (v) { return ['bolo', 'doces', 'salgados', 'sugestao'].includes(v); })));
    if (clean.cakeChoice === 'include' && !clean.components.includes('bolo')) clean.components.push('bolo');
    else if (clean.cakeChoice && clean.cakeChoice !== 'include') clean.components = clean.components.filter(function (v) { return v !== 'bolo'; });
    if (typeof source.date === 'string' && source.date && !validationErrors({ date: source.date }).date) clean.date = source.date;
    if (typeof source.time === 'string' && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(source.time)) clean.time = source.time;
    var cake = (catalog || []).find(function (p) { return p.title === source.selectedCake && eligibleProduct(p, 'bolos'); });
    if (cake) clean.selectedCake = cake.title;
    clean.items = selectedProducts(source,catalog).map(function(item){return {variantId:item.variantId,quantity:item.quantity};});
    clean.flowVersion = 2;
    return clean;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function labelFor(list, value) {
    var match = list.find(function (item) { return item[0] === value; });
    return match ? match[1] : '';
  }

  function eligibleProduct(product, collection) {
    return Boolean(
      product &&
      product.published === true &&
      product.available === true &&
      product.collection === collection &&
      Array.isArray(product.variants) &&
      product.variants.some(function (variant) {
        return variant && variant.available === true && variant.id != null &&
          Number.isInteger(variant.priceCents) && variant.priceCents > 0;
      })
    );
  }

  function parseHubContext(search, catalog) {
    var params = new URLSearchParams(String(search || ''));
    var peopleValues = params.getAll('people');
    var rawPeople = String(peopleValues.length === 1 ? peopleValues[0] : '').trim();
    var people = /^\d+$/.test(rawPeople) && Number(rawPeople) >= 1 && Number(rawPeople) <= 500
      ? rawPeople
      : '';
    var productValues = params.getAll('product');
    var handle = productValues.length === 1 ? productValues[0] : '';
    var cake = (Array.isArray(catalog) ? catalog : []).find(function (product) {
      return product && product.handle === handle && eligibleProduct(product, 'bolos');
    });
    var context = { people: people, selectedCake: cake ? cake.title : '' };
    [['event', EVENTS, 'event'], ['cake', CAKE_CHOICES, 'cakeChoice'], ['foodRole', FOOD_ROLES, 'foodRole']].forEach(function (entry) {
      var values = params.getAll(entry[0]);
      if (values.length === 1 && labelFor(entry[1], values[0])) context[entry[2]] = values[0];
    });
    var choices = params.getAll('components');
    if (choices.length === 1 && choices[0].split(',').every(function (value) { return ['doces', 'salgados', 'sugestao'].includes(value); })) context.components = Array.from(new Set(choices[0].split(',')));
    return context;
  }

  function availableComponents(catalog) {
    var products = Array.isArray(catalog) ? catalog : [];
    var hasAnyEligibleProduct = products.some(function (product) {
      return COMPONENT_DEFINITIONS.some(function (definition) {
        return definition[3] && eligibleProduct(product, definition[3]);
      });
    });
    return COMPONENT_DEFINITIONS.filter(function (definition) {
      if (!definition[3]) return hasAnyEligibleProduct;
      return products.some(function (product) { return eligibleProduct(product, definition[3]); });
    });
  }

  function selectedLabels(list, values) {
    return values.map(function (value) { return labelFor(list, value); }).filter(Boolean);
  }

  function untranslated(value) { return value; }

  function cakeIntention(state, translate) {
    var t = translate || untranslated;
    if (state.cakeChoice === 'have') return t('Já temos bolo');
    if (state.cakeChoice === 'none') return t('Não incluir bolo');
    if (state.cakeChoice === 'undecided' || (!state.cakeChoice && !state.components.includes('bolo'))) return t('Ainda por decidir');
    var details = [];
    if (state.selectedCake) details.push(state.selectedCake);
    if (state.cakeStyle) details.push(t(labelFor(CAKE_STYLES, state.cakeStyle)));
    if (state.colors.trim()) details.push(t('cores') + ': ' + state.colors.trim());
    if (state.flavor.trim()) details.push(t('sabor/recheio') + ': ' + state.flavor.trim());
    if (state.cakeMessage.trim()) details.push(t('mensagem') + ': ' + state.cakeMessage.trim());
    if (state.inspiration.trim()) details.push(t('referência') + ': ' + state.inspiration.trim());
    return t('Incluir bolo') + (details.length ? ' · ' + details.join(' · ') : ' · ' + t('Detalhes a confirmar'));
  }

  function missingInformation(state) {
    var missing = [];
    if (!state.event) missing.push('ocasião');
    if (!String(state.people).trim()) missing.push('número de pessoas');
    if (!state.components.length) missing.push('o que pretende');
    if ((!state.cakeChoice && !state.components.includes('bolo')) || state.cakeChoice === 'undecided') missing.push('bolo');
    if (state.hubCakeConflict) missing.push('já existe um bolo no pedido — reveja a escolha');
    if (!state.date) missing.push('data');
    return missing;
  }

  function summaryData(state, componentDefinitions, translate) {
    var components = componentDefinitions || COMPONENT_DEFINITIONS;
    var t = translate || untranslated;
    return {
      event: t(labelFor(EVENTS, state.event) || 'Por definir'),
      people: String(state.people).trim() || t('Por definir'),
      components: selectedLabels(components, state.components).map(t).join(', ') || t('Por definir'),
      cake: cakeIntention(state, t),
      level: t(labelFor(LEVELS, state.level) || 'Por definir'),
      foodRole: t(labelFor(FOOD_ROLES, state.foodRole) || 'Por definir'),
      date: state.date || t('Por definir'),
      time: state.time || t('Por definir'),
      reception: t('Recolha na Pontinha'),
      allergies: state.allergies.trim() || t('Nada indicado'),
      notes: state.notes.trim() || t('Sem observações'),
      budget: (state.budget || '').trim(),
      missing: missingInformation(state).map(t),
    };
  }

  // Free text stays in this tab; every handoff reads the current fields, including clears.
  function detailLines(state, options) {
    var fields = [['time', 'Hora pretendida'], ['budget', 'Orçamento disponível (€)'], ['allergies', 'Alergias/restrições a confirmar'], ['notes', 'Observações']];
    if (state.cakeChoice === 'include' || (!state.cakeChoice && state.components.includes('bolo'))) fields.push(['flavor', 'Sabor/recheio pretendido'], ['colors', 'Cores pretendidas'], ['cakeMessage', 'Mensagem no bolo'], ['inspiration', 'Tema ou referência']);
    var lines = fields.filter(function (field) { return String(state[field[0]] || '').trim(); }).map(function (field) { return field[1] + ': ' + String(state[field[0]]).trim(); });
    /* 26 Out 2026: os detalhes seguem sempre com o pedido (decisão da dona). */
    return lines;
  }

  /* 26 Out 2026: mensagem com rótulos em negrito, campos vazios omitidos e sem linhas vazias seguidas.
     Por decisão da dona, a mensagem enviada inclui alergias, orçamento e detalhes do bolo (options.publicOnly já não retira nada). */
  function buildWhatsAppMessage(state, componentDefinitions, translate) {
    var t = translate || untranslated;
    var en = typeof window !== 'undefined' && window.larrysaLang === 'en';
    var components = componentDefinitions || COMPONENT_DEFINITIONS;
    function f(label, value) { value = value == null ? '' : String(value).trim(); return value ? '*' + t(label) + ':* ' + value : ''; }
    function d(iso) { var p = String(iso || '').split('-'); return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : String(iso || ''); }
    var cakeIncluded = state.cakeChoice === 'include' || (!state.cakeChoice && state.components.includes('bolo'));
    var cake = '';
    if (state.cakeChoice === 'have') cake = t('Já temos bolo');
    else if (state.cakeChoice === 'none') cake = t('Não incluir bolo');
    else if (cakeIncluded) cake = [t('Incluir bolo'), state.selectedCake, state.cakeStyle ? t(labelFor(CAKE_STYLES, state.cakeStyle)) : ''].filter(Boolean).join(' · ');
    var budget = String(state.budget || '').trim();
    var party = [
      f('Ocasião', state.event ? t(labelFor(EVENTS, state.event)) : ''),
      f('Pessoas', String(state.people || '').trim()),
      f('O que pretende', selectedLabels(components, state.components).map(t).join(', ')),
      f('Refeição', state.foodRole ? t(labelFor(FOOD_ROLES, state.foodRole)) : ''),
      f('Nível', state.level ? t(labelFor(LEVELS, state.level)) : '')
    ];
    var cakeLines = [
      f('Bolo', cake),
      cakeIncluded ? f('Sabor ou recheio', state.flavor) : '',
      cakeIncluded ? f('Cores', state.colors) : '',
      cakeIncluded ? f('Mensagem no bolo', state.cakeMessage) : '',
      cakeIncluded ? f('Tema ou referência', state.inspiration) : ''
    ];
    var when = [
      f('Data', state.date ? d(state.date) : ''),
      f('Hora', state.time),
      f('Receção', t('Recolha na Pontinha')),
      f('Orçamento disponível', budget ? (en ? '€' + budget : budget + ' €') + ' (' + t('a proposta será confirmada') + ')' : ''),
      f('Alergias', state.allergies),
      f('Observações', state.notes)
    ];
    var chosen = Array.isArray(state.hubSelection) && state.hubSelection.length ? ['*' + t('Produtos já escolhidos') + ':*'].concat(state.hubSelection) : [];
    return [
      [t("Olá, Larrysa's Bakery! Tudo bem? Gostaria de pedir um orçamento para uma festa.")],
      party, cakeLines, when, chosen, (state.selectedProductLines||[]).length ? [t('Seleção do planeador')+':'].concat(state.selectedProductLines,[t('Subtotal dos produtos escolhidos')+': '+formatMoney(state.selectedTotalCents||0)]) : [],
      [t('Quantidades a confirmar por mensagem.'), t('Podem confirmar a disponibilidade e o valor final? Obrigado!')]
    ].map(function (block) { return block.filter(function (line) { return line && String(line).trim(); }).join('\n'); })
      .filter(Boolean).join('\n\n');
  }

  function plannerTelemetry(state) {
    var people = Number(state.people);
    var guestCountBand = !people ? 'unknown' : people <= 12 ? '1-12' : people <= 30 ? '13-30' : people <= 60 ? '31-60' : '61+';
    return {
      guest_count_band: guestCountBand,
      component_count: state.components.length,
      level: state.level || 'undefined',
      reception: state.reception || 'undefined',
    };
  }

  function choiceButton(name, value, label, selected, description) {
    return '<button type="button" class="fpv1-choice' + (selected ? ' is-selected' : '') + '"' +
      ' data-choice="' + name + '" data-value="' + escapeHtml(value) + '" aria-pressed="' + selected + '">' +
      '<span class="fpv1-choice__title">' + escapeHtml(label) + '</span>' +
      (description ? '<span class="fpv1-choice__desc">' + escapeHtml(description) + '</span>' : '') +
      '</button>';
  }

  function fieldset(legend, content, hint) {
    return '<fieldset class="fpv1-group"><legend>' + escapeHtml(legend) + '</legend>' +
      (hint ? '<p class="fpv1-hint">' + escapeHtml(hint) + '</p>' : '') + content + '</fieldset>';
  }

  function inputField(label, name, value, options) {
    var config = options || {};
    var type = config.type || 'text';
    var element = config.multiline
      ? '<textarea maxlength="1000" id="fpv1-' + name + '" data-input="' + name + '" rows="3" placeholder="' + escapeHtml(config.placeholder || '') + '">' + escapeHtml(value) + '</textarea>'
      : '<input maxlength="250" id="fpv1-' + name + '" data-input="' + name + '" type="' + type + '" value="' + escapeHtml(value) + '"' +
        (config.placeholder ? ' placeholder="' + escapeHtml(config.placeholder) + '"' : '') +
        (config.min ? ' min="' + config.min + '"' : '') + (config.max ? ' max="' + config.max + '"' : '') + (name === 'budget' ? ' step="any"' : '') + '>';
    return '<label class="fpv1-field" for="fpv1-' + name + '"><span>' + escapeHtml(label) + '</span>' + element + '</label>';
  }

  function renderProgress(step) {
    var labels = ['A festa', 'O menu', 'Os detalhes', 'Rever pedido'];
    return '<div class="fpv1-progress" aria-label="Progresso do planeador">' +
      '<div class="fpv1-progress__bar" role="progressbar" aria-valuemin="1" aria-valuemax="4" aria-valuenow="' + step + '">' +
      '<span style="width:' + (step / 4 * 100) + '%"></span></div>' +
      '<ol>' + labels.map(function (label, index) {
        var number = index + 1;
        return '<li class="' + (number === step ? 'is-current' : number < step ? 'is-done' : '') + '">' + escapeHtml(label) + '</li>';
      }).join('') + '</ol></div>';
  }

  function todayISO() {
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function validationErrors(state, today) {
    var errors = {};
    if (state.people && (!/^\d+$/.test(String(state.people)) || Number(state.people) < 1 || Number(state.people) > 500)) {
      errors.people = 'Indique um número inteiro entre 1 e 500 pessoas, ou deixe por definir.';
    }
    if (state.date) {
      var d = new Date(state.date + 'T12:00:00Z');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(state.date) || Number.isNaN(d.getTime()) || d.toISOString().slice(0, 10) !== state.date || state.date < (today || todayISO())) {
        errors.date = 'Escolha uma data a partir de hoje, ou deixe por definir.';
      }
    }
    if (state.budget && (!Number.isFinite(Number(state.budget)) || Number(state.budget) <= 0 || Number(state.budget) > 100000)) {
      errors.budget = 'Indique um orçamento superior a zero, ou deixe o campo em branco.';
    }
    return errors;
  }

  function stepOne(state) {
    var eventButtons = EVENTS.map(function (item) {
      return choiceButton('event', item[0], item[1], state.event === item[0]);
    }).join('');
    return '<section class="fpv1-step" aria-labelledby="fpv1-title">' +
      '<h2 id="fpv1-title">Diga-nos como vai ser a festa</h2>' +
      '<p class="fpv1-intro">Escolha a ocasião e indique quantas pessoas vêm. Pode deixar por definir o que ainda não souber.</p>' +
      '<div class="fpv1-fields fpv1-fields--two">' +
      inputField('Número estimado de pessoas', 'people', state.people, { type: 'number', min: '1', max: '500', placeholder: 'Ex.: 20' }) + '</div>' +
      fieldset('Qual é a ocasião?', '<div class="fpv1-grid fpv1-grid--events">' + eventButtons + '</div>') +
      '</section>';
  }


  function experienceText(pt, en) { return typeof window !== 'undefined' && window.larrysaLang === 'en' ? en : pt; }
  function formatMoney(cents) { return new Intl.NumberFormat(experienceText('pt-PT','en-IE'), {style:'currency',currency:'EUR'}).format(cents/100); }
  function selectedProducts(state, catalog) {
    var seen = new Set();
    return (Array.isArray(state.items) ? state.items : []).flatMap(function(item) {
      if(!item || !/^\d+$/.test(String(item.quantity)) || !Number.isInteger(Number(item.quantity)) || Number(item.quantity)<1 || Number(item.quantity)>99) return [];
      var product=(catalog||[]).find(function(p){return eligibleProduct(p,p.collection) && p.variants.some(function(v){return String(v.id)===String(item.variantId);});});
      if(!product || (['have','none'].includes(state.cakeChoice) && product.collection==='bolos')) return [];
      var variant=product.variants.find(function(v){return String(v.id)===String(item.variantId) && v.available===true && Number.isInteger(v.priceCents) && v.priceCents>0;});
      if(!variant || seen.has(String(variant.id))) return [];
      seen.add(String(variant.id));
      return [{variantId:String(variant.id),quantity:Number(item.quantity),priceCents:variant.priceCents,title:product.title,variantTitle:variant.title||'',image:product.image||'',collection:product.collection}];
    });
  }
  function selectedLines(state,catalog) {
    return selectedProducts(state,catalog).map(function(item){return item.quantity+' × '+item.title+(item.variantTitle && !/^Default(?: Title)?$/.test(item.variantTitle)?' · '+item.variantTitle:'')+' — '+formatMoney(item.priceCents*item.quantity);});
  }
  function variantLabel(value){return typeof window!=='undefined'&&window.larrysaLang==='en'?String(value).replace(/(\d+) unidades/g,'$1 pieces'):value;}
  function safePhoto(url) { return /^(https:\/\/|\/\/|\/(?!\/))/.test(String(url||'')) ? escapeHtml(url) : ''; }
  function visualMenu(state,catalog,reference) {
    var t=experienceText;
    var selected=selectedProducts(state,catalog);
    var total=selected.reduce(function(sum,item){return sum+item.priceCents*item.quantity;},0);
    var category=state.menuCategory||'salgados';
    var products=(catalog||[]).filter(function(p){return p.collection===category && eligibleProduct(p,category) && !(category==='bolos' && ['have','none'].includes(state.cakeChoice));});
    var selectedHtml=selected.length ? '<ul class="fpv1-selection">'+selected.map(function(item){return '<li>'+(safePhoto(item.image)?'<img src="'+safePhoto(item.image)+'" alt="" width="72" height="90" loading="lazy">':'')+'<div><strong>'+escapeHtml(item.title)+'</strong><span>'+escapeHtml(/^Default(?: Title)?$/.test(item.variantTitle)?'':item.variantTitle)+'</span><span>'+escapeHtml(formatMoney(item.priceCents*item.quantity))+'</span><label>'+t('Quantidade','Quantity')+'<input type="number" required min="1" max="99" step="1" data-item-quantity="'+escapeHtml(item.variantId)+'" value="'+item.quantity+'" aria-label="'+escapeHtml(t('Quantidade de ','Quantity of ')+item.title+' '+item.variantTitle)+'"></label><button type="button" class="fpv1-remove" data-remove-item="'+escapeHtml(item.variantId)+'">'+t('Retirar','Remove')+'</button></div></li>';}).join('')+'</ul>' : '<p class="fpv1-selection-empty">'+t('Comece com um salgado. Ou vá já ao bolo. A mesa é sua.','Start with something savoury. Or go straight to the cake. Make it yours.')+'</p>';
    var tabs=[['salgados','Salgados','Savouries'],['bolos','Bolos','Cakes'],['sobremesas','Sobremesas','Desserts']].map(function(item){return '<button type="button" data-menu-category="'+item[0]+'" aria-pressed="'+(category===item[0])+'">'+t(item[1],item[2])+'</button>';}).join('');
    var tiles=products.map(function(p,index){var variants=p.variants.filter(function(v){return v.available===true && Number.isInteger(v.priceCents) && v.priceCents>0;});return '<article class="fpv1-product">'+(safePhoto(p.image)?'<img src="'+safePhoto(p.image)+'" alt="'+escapeHtml(p.title)+'" width="180" height="225" loading="lazy">':'')+'<h4>'+escapeHtml(p.title)+'</h4><label for="fpv1-variant-'+index+'">'+t('Formato e preço','Format and price')+'</label><select id="fpv1-variant-'+index+'">'+variants.map(function(v){return '<option value="'+escapeHtml(String(v.id))+'"'+(state.menuVariants[p.handle]===String(v.id)?' selected':'')+'>'+escapeHtml((/^Default(?: Title)?$/.test(v.title)?t('Unidade','Unit'):variantLabel(v.title)||t('Unidade','Unit'))+' · '+formatMoney(v.priceCents))+'</option>';}).join('')+'</select><button type="button" data-add-item="fpv1-variant-'+index+'">'+t('Juntar à seleção','Add to selection')+'</button></article>';}).join('');
    return '<section class="fpv1-visual" aria-labelledby="fpv1-table-title"><h3 id="fpv1-table-title">'+t('Escolha ao seu gosto','Choose your favourites')+'</h3><div class="fpv1-categories" aria-label="'+t('Categorias de produtos','Product categories')+'">'+tabs+'</div><details class="fpv1-selection-review"'+(state.selectionOpen?' open':'')+' data-details="selectionOpen"><summary>'+t('A sua seleção','Your selection')+' · '+escapeHtml(formatMoney(total))+'</summary>'+selectedHtml+'<p class="fpv1-total" role="status">'+t('Subtotal dos produtos escolhidos','Selected products subtotal')+' <strong>'+escapeHtml(formatMoney(total))+'</strong></p><p class="fpv1-hint">'+t('A quantidade refere-se ao formato indicado: 2 packs de 20 são 40 unidades. A adequação ao número de pessoas e eventuais extras são confirmados consigo.','Quantities refer to the stated format: 2 packs of 20 are 40 pieces. Suitability for your guests and any extras are confirmed with you.')+'</p></details><div class="fpv1-browse"><button type="button" data-browse="-1">'+t('Anteriores','Previous')+'</button><span>'+t('Deslize para explorar','Swipe to explore')+'</span><button type="button" data-browse="1">'+t('Mais produtos','More products')+'</button></div><div class="fpv1-products" data-category="'+category+'">'+(tiles||'<p>'+t('Esta categoria não tem opções para a escolha atual. Pode mudar a sua indicação sobre o bolo acima ou pedir ajuda.','No products match your current choice. Change your cake preference above or ask for help.')+'</p>')+'</div></section>';

  }

  function stepTwo(state, components, catalog, reference) {
    var cakeButtons = CAKE_CHOICES.map(function (item) { return choiceButton('cakeChoice', item[0], item[1], state.cakeChoice === item[0]); }).join('');
    var componentButtons = components.filter(function (item) { return item[0] !== 'bolo'; }).map(function (item) { return choiceButton('components', item[0], item[1], state.components.includes(item[0])); }).join('');
    return '<section class="fpv1-step" aria-labelledby="fpv1-title"><h2 id="fpv1-title">O que gostaria de ter na mesa?</h2>' +
      '<p class="fpv1-intro">Junte os produtos que lhe apetecem. Pode também deixar a escolha connosco.</p>' +
      fieldset('E o bolo?', '<div class="fpv1-grid fpv1-grid--cake">' + cakeButtons + '</div>') +
      '<details class="fpv1-details"><summary>Prefiro pedir uma sugestão</summary><div class="fpv1-grid fpv1-grid--components">' + componentButtons + '</div></details>' +
      visualMenu(state,catalog,reference) + '</section>';
  }

  function stepDetails(state) {
    var foodButtons = FOOD_ROLES.map(function (item) { return choiceButton('foodRole', item[0], item[1], state.foodRole === item[0]); }).join('');
    var cakeFields = state.components.includes('bolo')
      ? '<details class="fpv1-details" data-details="cakeDetailsOpen"' + (state.cakeDetailsOpen ? ' open' : '') + '><summary>Detalhes do bolo (opcional)</summary>' +
        '<div class="fpv1-fields fpv1-fields--two">' +
        inputField('Sabor ou recheio', 'flavor', state.flavor, { placeholder: 'Ex.: chocolate' }) +
        inputField('Cores', 'colors', state.colors, { placeholder: 'Ex.: creme e verde' }) +
        inputField('Mensagem no bolo', 'cakeMessage', state.cakeMessage, { placeholder: 'Ex.: Parabéns, Mia' }) +
        inputField('Tema ou referência', 'inspiration', state.inspiration, { placeholder: 'Pode enviar fotografias depois, no WhatsApp' }) + '</div></details>' : '';
    return '<section class="fpv1-step" aria-labelledby="fpv1-title"><h2 id="fpv1-title">Vamos combinar os detalhes</h2>' +
      '<p class="fpv1-intro">Indique o que já sabe. Confirmamos consigo a disponibilidade e os restantes detalhes.</p>' +
      '<div class="fpv1-fields fpv1-fields--two">' + inputField('Data da festa', 'date', state.date, {type:'date',min:todayISO()}) + '</div>' + cakeFields +
      '<details class="fpv1-details"><summary>Como vai servir a comida? (opcional)</summary>' + fieldset('Qual será o papel da comida? (opcional)', '<div class="fpv1-grid fpv1-grid--reception">' + foodButtons + '</div>') + '</details>' +
      fieldset('Recolha', '<p class="fpv1-hint">Pode levar a sua encomenda na Pontinha. Se preferir que um estafeta (Uber, Bolt ou outro) a venha buscar, o transporte e o cuidado com o bolo ficam a seu cargo a partir da recolha.</p>') +
      '<div class="fpv1-fields fpv1-fields--two">' +
      inputField('Hora pretendida (opcional)', 'time', state.time, { type: 'time' }) +
      inputField('Orçamento disponível em € (opcional)', 'budget', state.budget, { type: 'number', min: '1', max: '100000', placeholder: 'Para o pedido completo' }) + '</div>' +
      '<details class="fpv1-details" data-details="extraDetailsOpen"' + (state.extraDetailsOpen ? ' open' : '') + '><summary>Alergias e restrições (opcional)</summary><div class="fpv1-fields">' +
      inputField('Alergias ou restrições a confirmar', 'allergies', state.allergies, { multiline: true, placeholder: 'Falamos consigo antes de confirmar o pedido' }) +
      '</div></details>' +
      inputField('Observações (opcional)', 'notes', state.notes, { multiline: true, placeholder: 'O que mais precisamos de saber?' }) +
      '<p class="fpv1-hint">As notas pessoais e indicações livres não são recuperadas ao atualizar a página. Copie o pedido completo antes de sair se quiser guardá-las.</p>' +
      '</section>';
  }

  function summaryRow(label, value) {
    return '<div class="fpv1-summary__row"><dt>' + escapeHtml(label) + '</dt><dd translate="no">' + escapeHtml(value) + '</dd></div>';
  }

  function stepFive(state, components, whatsappNumber) {
    var t = typeof window !== 'undefined' && window.larrysaT ? window.larrysaT : untranslated;
    var summary = summaryData(state, components, t);
    var missing = summary.missing.length
      ? '<div class="fpv1-missing" role="status"><h3>A combinar consigo</h3><ul>' + summary.missing.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul><p>Pode enviar o pedido e acertar estes detalhes connosco no WhatsApp.</p></div>'
      : '<div class="fpv1-complete" role="status">O pedido tem toda a informação essencial.</div>';
    var message = buildWhatsAppMessage(state, components, t);
    var publicMessage = buildWhatsAppMessage(state, components, t, { publicOnly: true });
    var url = 'https://wa.me/' + (whatsappNumber || WA_NUMBER) + '?text=' + encodeURIComponent(publicMessage);
    return '<section class="fpv1-step fpv1-step--summary" aria-labelledby="fpv1-title">' +
      '<h2 id="fpv1-title">Reveja o pedido antes de enviar</h2>' +
      '<p class="fpv1-intro">Confirme os dados abaixo. Ao abrir o WhatsApp, pode ainda editar a mensagem antes de a enviar; a encomenda fica confirmada depois de combinarmos os detalhes consigo.</p>' +
      (state.hubCakeConflict ? '<p class="fpv1-alert" role="alert">Escolheu não acrescentar bolo, mas já existe um bolo no pedido. Reveja a escolha antes de enviar; nada foi removido automaticamente.</p>' : '') +
      '<div class="fpv1-summary"><dl>' +
      summaryRow('Ocasião', summary.event) + summaryRow('Pessoas', summary.people) +
      summaryRow('Menu', summary.components) +
      summaryRow('Refeição', summary.foodRole) +
      summaryRow('Bolo', summary.cake) +
      (summary.budget ? summaryRow('Orçamento disponível', summary.budget + ' €') : '') +
      summaryRow('Data e hora', summary.date + ' · ' + summary.time) +
      summaryRow('Receção', summary.reception) + summaryRow('Alergias/restrições', summary.allergies) +
      summaryRow('Observações', summary.notes) + '</dl></div>' + missing +
      (state.hubSelection && state.hubSelection.length ? '<h3>Produtos já escolhidos</h3><ul>' + state.hubSelection.map(function (line) { return '<li>' + escapeHtml(line) + '</li>'; }).join('') + '</ul><p>Estes produtos continuam no pedido. O planeador não os duplica.</p>' : '') +
      ((state.selectedProductLines||[]).length ? '<h3>'+experienceText('Seleção do planeador','Planner selection')+'</h3><ul>'+state.selectedProductLines.map(function(line){return '<li>'+escapeHtml(line)+'</li>';}).join('')+'</ul><p>'+experienceText('Subtotal dos produtos escolhidos','Selected products subtotal')+': <strong>'+escapeHtml(formatMoney(state.selectedTotalCents||0))+'</strong></p>' : '') +
      '<div class="fpv1-actions"><button type="button" data-action="edit-event">Alterar dados da festa</button><button type="button" data-action="edit-menu">Alterar menu</button><button type="button" data-action="edit-details">Alterar detalhes</button></div>' +
      '<p class="fpv1-final-notice">' + escapeHtml(FINAL_NOTICE) + '</p>' +
      '<p>A ligação do WhatsApp prepara a mensagem completa abaixo, incluindo as indicações que escreveu. Reveja-a antes de continuar e retire no WhatsApp o que não quiser enviar.</p>' +
      '<button type="button" data-action="copy-request">Copiar pedido completo</button>' +
      '<p role="status" data-copy-status></p>' +
      '<details><summary>Mensagem completa para copiar</summary><textarea readonly rows="8" aria-label="Pedido completo para copiar" data-copy-review>' + escapeHtml(message) + '</textarea></details>' +
      '<a class="fpv1-whatsapp" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">Abrir pedido no WhatsApp</a>' +
      '</section>';
  }

  function compactSummary(state,catalog) {
    var lines=selectedLines(state,catalog);
    return '<details class="fpv1-selection-review"><summary>'+experienceText('Resumo da festa','Party summary')+'</summary><p>'+escapeHtml(labelFor(EVENTS,state.event)||experienceText('Ocasião por definir','Occasion to confirm'))+' · '+escapeHtml(state.people||'—')+' '+experienceText('pessoas','guests')+'</p>'+(lines.length?'<ul>'+lines.map(function(line){return '<li>'+escapeHtml(line)+'</li>';}).join('')+'</ul>':'')+'</details>';
  }

  function navigation(state) {
    if (state.step === 1) return '<div class="fpv1-actions"><span></span><button type="button" class="fpv1-next" data-action="next">Continuar</button></div>';
    if (state.step === 4) return '<div class="fpv1-actions"><button type="button" class="fpv1-back" data-action="back">Voltar</button></div>';
    return '<div class="fpv1-actions"><button type="button" class="fpv1-back" data-action="back">Voltar</button><button type="button" class="fpv1-next" data-action="next">' + (state.step === 3 ? 'Rever pedido' : 'Continuar') + '</button></div>';
  }

  function createPlanner(rootElement, catalog, options, hubContext) {
    catalog=(catalog||[]).map(function(product){var photos=typeof window!=='undefined'&&window.BakeryMedia?window.BakeryMedia.images(product.handle):[];return photos.length?Object.assign({},product,{image:photos[0].u}):product;});
    var state = Object.assign(initialState(), persistablePlan(options && options.savedPlan, catalog));
    var components = availableComponents(catalog);
    var context = hubContext || {};
    function applyContext(context) {
      if (Object.hasOwn(context, 'people')) state.people = /^\d+$/.test(context.people) && Number(context.people) >= 1 && Number(context.people) <= 500 ? String(context.people) : '';
      if (labelFor(EVENTS, context.event)) state.event = context.event;
      if (labelFor(CAKE_CHOICES, context.cakeChoice)) state.cakeChoice = context.cakeChoice;
      if (labelFor(FOOD_ROLES, context.foodRole)) state.foodRole = context.foodRole;
      if (Array.isArray(context.components)) state.components = context.components.filter(function (value) { return ['doces', 'salgados', 'sugestao'].includes(value); });
      if (Object.hasOwn(context, 'date') && (!context.date || /^\d{4}-\d{2}-\d{2}$/.test(context.date))) state.date = context.date;
      if (labelFor(RECEPTION, context.reception)) state.reception = context.reception;
      if (Object.hasOwn(context, 'selectedCake')) state.selectedCake = context.selectedCake || '';
      if (state.selectedCake && !state.cakeChoice) state.cakeChoice = 'include';
      if (state.cakeChoice) {
        if (state.cakeChoice === 'include' && !state.components.includes('bolo')) state.components.push('bolo');
        else if (state.cakeChoice !== 'include') state.components = state.components.filter(function (value) { return value !== 'bolo'; });
      }
    }
    applyContext(context);
    var whatsappNumber = options && options.whatsappNumber ? String(options.whatsappNumber) : WA_NUMBER;
    var lastReviewSignature = '';
    var started = false;
    var completedSteps = {};
    var menuOffsets = {};

    function emitProgress(action, field) {
      if (typeof document === 'undefined' || typeof CustomEvent !== 'function') return;
      var detail = { action: action, step: state.step };
      if (field) detail.field = field;
      try {
        document.dispatchEvent(new CustomEvent('larrysa:planner-progress', { detail: detail }));
      } catch (error) { /* Measurement must never block the form. */ }
    }

    function markStarted() {
      if (started) return;
      started = true;
      emitProgress('started');
    }


    function emitReview() {
      if (state.step !== 4 || typeof document === 'undefined' || typeof CustomEvent !== 'function') return;
      var telemetry = plannerTelemetry(state);
      var signature = JSON.stringify(telemetry);
      if (signature === lastReviewSignature) return;
      try {
        document.dispatchEvent(new CustomEvent('larrysa:planner-reviewed', { detail: telemetry }));
        lastReviewSignature = signature;
      } catch (error) {}
    }

    function render() {
      var previousMenu=rootElement.querySelector('.fpv1-products');if(previousMenu)menuOffsets[previousMenu.dataset.category]=previousMenu.scrollLeft;
      if(typeof window!=="undefined" && window.LARRYSA_EN) Object.assign(window.LARRYSA_EN,{"Os detalhes": "The details", "Escolha a ocasião e indique quantas pessoas vêm. Pode deixar por definir o que ainda não souber.": "Choose the occasion and tell us how many guests are coming. Leave anything undecided for later.", "Junte os produtos que lhe apetecem. Pode também deixar a escolha connosco.": "Add the products you like, or ask us to choose with you.", "Prefiro pedir uma sugestão": "I would like a suggestion", "Vamos combinar os detalhes": "Let’s arrange the details", "Indique o que já sabe. Confirmamos consigo a disponibilidade e os restantes detalhes.": "Tell us what you know. We will confirm availability and the remaining details with you.", "Como vai servir a comida? (opcional)": "How will you serve the food? (optional)", "Alterar menu": "Edit menu", "Alterar detalhes": "Edit details"});
      if (typeof window !== 'undefined' && window.LARRYSA_EN) Object.assign(window.LARRYSA_EN,{"Seleção do planeador": "Planner selection", "Subtotal dos produtos escolhidos": "Selected products subtotal", "Copiar pedido completo": "Copy complete request", "Abrir pedido no WhatsApp": "Open request in WhatsApp", "Pode escolher várias opções ou pedir-nos uma sugestão. Escolha produtos e quantidades se já tiver uma ideia, ou deixe-nos ajudar com a proposta.": "Choose products and quantities if you have something in mind, or ask us to suggest a menu.", "A ligação do WhatsApp prepara a mensagem completa abaixo, incluindo as indicações que escreveu. Reveja-a antes de continuar e retire no WhatsApp o que não quiser enviar.": "The WhatsApp link prepares the complete message below, including your notes. Review it before continuing and remove anything you do not want to send in WhatsApp.","Alterar menu e indicações":"Edit menu and notes","Mensagem completa para copiar":"Complete message to copy"});

      state.items=selectedProducts(state,catalog).map(function(item){return {variantId:item.variantId,quantity:item.quantity};});
      state.selectedProductLines=selectedLines(state,catalog);
      state.selectedTotalCents=selectedProducts(state,catalog).reduce(function(sum,item){return sum+item.priceCents*item.quantity;},0);
      savePlan();
      if (options && typeof options.getSelection === 'function') state.hubSelection = options.getSelection();
      state.hubCakeConflict = Boolean(options && options.hasCake && options.hasCake() && ['have','none'].includes(state.cakeChoice));
      var content = state.step === 1 ? stepOne(state)
        : state.step === 2 ? stepTwo(state, components, catalog, options && options.referenceImage)
        : state.step === 3 ? stepDetails(state)
        : stepFive(state, components, whatsappNumber);
      rootElement.innerHTML = '<div class="fpv1-card">' + renderProgress(state.step) +
        '<div class="fpv1-body">' + (options && options.savedPlan ? '<p class="fpv1-hint" role="status">Recuperámos as escolhas gerais da festa neste separador. Reveja os dados e volte a indicar notas pessoais, se necessário.</p>' : '') +
        (storageFailed ? '<p class="fpv1-hint" role="status">Não foi possível guardar as escolhas neste separador. Mantenham esta página aberta até copiarem o pedido.</p>' : '') + content + (state.step !== 2 && state.step !== 4 ? compactSummary(state,catalog) : '') + navigation(state) + '<details><summary>Começar novo plano</summary><p>Copie primeiro o pedido completo se quiser guardar as notas. Limpar este plano não altera os produtos do carrinho.</p><button type="button" data-action="restart">Limpar escolhas e começar</button></details></div></div>';
      rootElement.setAttribute('data-planner-ready', 'true');
      bind();
      var menu=rootElement.querySelector('.fpv1-products');if(menu)menu.scrollLeft=menuOffsets[state.menuCategory]||0;
      if (typeof window !== 'undefined' && window.larrysaApplyLang) window.larrysaApplyLang();
      emitReview();
    }

    function nextStep() {
      state.items=selectedProducts(state,catalog).map(function(item){return {variantId:item.variantId,quantity:item.quantity};});
      state.step = Math.min(4, state.step + 1);
    }

    function previousStep() {
      state.step = Math.max(1, state.step - 1);
    }

    function toggleList(field, value) {
      state[field] = state[field].includes(value)
        ? state[field].filter(function (item) { return item !== value; })
        : state[field].concat(value);
    }

    function focusHeading() {
      var heading = rootElement.querySelector('#fpv1-title');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        rootElement.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }

    var storageFailed = false;
    function savePlan() {
      if (options && typeof options.savePlan === 'function') storageFailed = options.savePlan(persistablePlan(state, catalog)) === false;
    }
    function notify() {
      savePlan();
      if (options && typeof options.onChange === 'function') options.onChange({ people: state.people, event: state.event, cakeChoice: state.cakeChoice, components: state.components.filter(function (item) { return item !== 'bolo'; }), foodRole: state.foodRole, date: state.date, reception: state.reception });
    }

    function bind() {
      rootElement.querySelectorAll('[data-browse]').forEach(function(button){button.addEventListener('click',function(){var menu=rootElement.querySelector('.fpv1-products');if(menu)menu.scrollBy({left:Number(button.dataset.browse)*menu.clientWidth*.85,behavior:typeof window!=='undefined'&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});});
      rootElement.querySelectorAll('[data-menu-category]').forEach(function(button){button.addEventListener('click',function(){state.menuCategory=button.dataset.menuCategory;render();var active=rootElement.querySelector('[data-menu-category="'+state.menuCategory+'"]');if(active)active.focus({preventScroll:true});});});
      rootElement.querySelectorAll('[data-add-item]').forEach(function(button){button.addEventListener('click',function(){
        var select=rootElement.querySelector('#'+button.dataset.addItem);if(!select)return;
        var id=select.value;var existing=state.items.find(function(item){return item.variantId===id;});
        if(existing)existing.quantity=Math.min(99,existing.quantity+1);else state.items.push({variantId:id,quantity:1});
        var product=(catalog||[]).find(function(p){return p.variants.some(function(v){return String(v.id)===id;});});
        if(product){state.menuVariants[product.handle]=id;var component={bolos:'bolo',salgados:'salgados',sobremesas:'doces'}[product.collection];if(component&&!state.components.includes(component))state.components.push(component);if(component==='bolo')state.cakeChoice='include';}
        notify();render();var added=rootElement.querySelector('[data-add-item="'+button.dataset.addItem+'"]');if(added)added.focus({preventScroll:true});
      });});
      rootElement.querySelectorAll('[data-remove-item]').forEach(function(button){button.addEventListener('click',function(){state.items=state.items.filter(function(item){return item.variantId!==button.dataset.removeItem;});notify();render();var heading=rootElement.querySelector('#fpv1-table-title');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}});});
      rootElement.querySelectorAll('[data-item-quantity]').forEach(function(input){
        input.addEventListener('input',function(){
          if(!input.checkValidity())return;
          var item=state.items.find(function(item){return item.variantId===input.dataset.itemQuantity;});if(item)item.quantity=Number(input.value);
          notify();
          var total=rootElement.querySelector('.fpv1-total strong');if(total)total.textContent=formatMoney(selectedProducts(state,catalog).reduce(function(sum,item){return sum+item.priceCents*item.quantity;},0));
        });
        input.addEventListener('change',function(){
        if(!input.checkValidity()){input.reportValidity();return;}
        var item=state.items.find(function(item){return item.variantId===input.dataset.itemQuantity;});if(item)item.quantity=Number(input.value);
        notify();render();var replacement=rootElement.querySelector('[data-item-quantity="'+input.dataset.itemQuantity+'"]');if(replacement)replacement.focus({preventScroll:true});
      });});
      rootElement.querySelectorAll('[data-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          markStarted();
          var field = button.getAttribute('data-choice');
          var value = button.getAttribute('data-value');
          if (field === 'components') toggleList(field, value);
          else state[field] = value;
          if (field === 'cakeChoice') {
            state.components = state.components.filter(function (item) { return item !== 'bolo'; });
            if (value === 'include') state.components.push('bolo');
          }
          notify();
          render();
          var replacement = Array.from(rootElement.querySelectorAll('[data-choice]')).find(function (candidate) {
            return candidate.getAttribute('data-choice') === field && candidate.getAttribute('data-value') === value;
          });
          if (replacement) replacement.focus({ preventScroll: true });
        });
      });
      rootElement.querySelectorAll('[data-details]').forEach(function (details) {
        details.addEventListener('toggle', function () { state[details.dataset.details] = details.open; });
      });
      rootElement.querySelectorAll('[data-input]').forEach(function (input) {
        input.addEventListener('input', function () { markStarted(); state[input.getAttribute('data-input')] = input.value; input.setCustomValidity(''); input.removeAttribute('aria-invalid'); notify(); });
      });
      rootElement.querySelectorAll('[data-action]').forEach(function (button) {
        button.addEventListener('click', async function () {
          var action = button.getAttribute('data-action');
          if (action === 'restart') { state = initialState(); if (options) options.savedPlan = null; started = false; completedSteps = {}; lastReviewSignature = ''; notify(); render(); focusHeading(); return; }
          if (action === 'copy-request') {
            var status = rootElement.querySelector('[data-copy-status]');
            try {
              if (typeof navigator === 'undefined' || !navigator.clipboard) throw new Error('clipboard_unavailable');
              var translate = typeof window !== 'undefined' && window.larrysaT ? window.larrysaT : untranslated;
              await navigator.clipboard.writeText(buildWhatsAppMessage(state, components, translate));
              if (status) status.textContent = 'Pedido completo copiado. Cole-no na conversa quando quiser partilhar estes detalhes.';
            } catch (error) {
              if (status) status.textContent = 'Não foi possível copiar automaticamente. Selecione e copie o texto abaixo.';
              var review = rootElement.querySelector('[data-copy-review]');
              if (review) { if (review.closest) review.closest('details').open = true; review.focus(); review.select(); }
            }
            return;
          }
          if (action === 'next') {
            markStarted();
            var errors = validationErrors(state);
            var firstInvalid = null;
            rootElement.querySelectorAll('[data-input],[data-item-quantity]').forEach(function (input) {
              var error = errors[input.getAttribute('data-input')] || '';
              input.setCustomValidity(typeof window !== 'undefined' && window.larrysaT ? window.larrysaT(error) : error);
              input.setAttribute('aria-invalid', input.validity.valid ? 'false' : 'true');
              if (!input.checkValidity() && !firstInvalid) firstInvalid = input;
            });
            if (firstInvalid) { var disclosure=firstInvalid.closest('details');if(disclosure)disclosure.open=true; emitProgress('validation_error', firstInvalid.getAttribute('data-input')); firstInvalid.reportValidity(); firstInvalid.focus(); return; }
            if (!completedSteps[state.step]) {
              completedSteps[state.step] = true;
              emitProgress('step_completed');
            }
            nextStep();
          }
          if (action === 'back') previousStep();
          if (action === 'edit-event') state.step = 1;
          if (action === 'edit-menu') state.step = 2;
          if (action === 'edit-details') state.step = 3;
          render();
          focusHeading();
        });
      });
    }

    if (typeof document !== 'undefined' && document.addEventListener) document.addEventListener('larrysa:group-choice-selected', function (event) {
      var handle = event && event.detail && event.detail.handle;
      var product = (catalog || []).find(function (item) { return item.handle === handle && eligibleProduct(item, 'bolos'); });
      if (!product) return;
      state.selectedCake = product.title;
      state.cakeChoice = 'include';
      if (!state.components.includes('bolo')) state.components.push('bolo');
      markStarted();
      render();
    });

    if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('larrysa:lang', function () {
      render();
    });
    render();
    return {
      refresh: function (context) { if (context) applyContext(context); render(); },
      getDetails: function (options) { return detailLines(state, options).concat(state.selectedProductLines||[],(state.selectedProductLines||[]).length?[experienceText('Subtotal dos produtos escolhidos','Selected products subtotal')+': '+formatMoney(state.selectedTotalCents||0)]:[]); },
      getState: function () { return { ...state, components: state.components.slice(), items:state.items.map(function(item){return {...item};}) }; },
    };
  }

  function mount(rootElement) {
    if (!rootElement) return null;
    var catalog = typeof window !== 'undefined' ? window.LARRYSA_SHOPIFY_CATALOG : [];
    var options = typeof window !== 'undefined' ? window.LARRYSA_PLANNER_CONFIG : {};
    var hasHandoff = typeof window !== 'undefined' && typeof window.LARRYSA_FESTA_HUB_SEARCH === 'string';
    var search = hasHandoff ? window.LARRYSA_FESTA_HUB_SEARCH
      : typeof window !== 'undefined' && window.location ? window.location.search : '';
    var hubContext = search ? parseHubContext(search, catalog) : {};
    var params = new URLSearchParams(search);
    if (!params.has('people')) delete hubContext.people;
    if (!params.has('product')) delete hubContext.selectedCake;
    if (hasHandoff) {
      try { delete window.LARRYSA_FESTA_HUB_SEARCH; } catch (error) { window.LARRYSA_FESTA_HUB_SEARCH = ''; }
    }
    var savedPlan;
    try { savedPlan = JSON.parse(window.sessionStorage.getItem('larrysa:party-plan:v1') || 'null'); } catch (error) {}
    return createPlanner(rootElement, catalog, Object.assign({}, options, {
      savedPlan: savedPlan && typeof savedPlan === 'object' && !Array.isArray(savedPlan) ? savedPlan : null,
      savePlan: function (state) {
        try { window.sessionStorage.setItem('larrysa:party-plan:v1', JSON.stringify(state)); return true; }
        catch (error) { return false; }
      },
    }), hubContext);
  }

  return Object.freeze({
    FINAL_NOTICE: FINAL_NOTICE,
    EVENTS: EVENTS,
    COMPONENT_DEFINITIONS: COMPONENT_DEFINITIONS,
    CAKE_STYLES: CAKE_STYLES,
    LEVELS: LEVELS,
    RECEPTION: RECEPTION,
    initialState: initialState,
    selectedProducts: selectedProducts,
    persistablePlan: persistablePlan,
    eligibleProduct: eligibleProduct,
    parseHubContext: parseHubContext,
    availableComponents: availableComponents,
    validationErrors: validationErrors,
    missingInformation: missingInformation,
    summaryData: summaryData,
    plannerTelemetry: plannerTelemetry,
    detailLines: detailLines,
    buildWhatsAppMessage: buildWhatsAppMessage,
    createPlanner: createPlanner,
    mount: mount,
  });
});
